// removed by extract-text-webpack-plugin
module.exports = {"notFoundWrap":"qempo_404_notFoundWrap-1AaCWtm","notFoundContent":"qempo_404_notFoundContent-1dMAZX9"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/error/components/404/404.scss
// module id = 1683
// module chunks = 0